// Disabling sort-key for fields that follow the expected order of columns in the generated report
/* eslint-disable sort-keys */
export const voucherDownload = {
  bulkVoucherDownload: {
    filename: "Voucher Group",
    fields: {
      code: "Voucher Code",
      groupCode: "Voucher Group",
      discountValue: "Discount Value",
      verticalType: "Classification",
      discountValueType: "Voucher Type",
      type: "Voucher Spec Info",
      minSpent: "Minimum Order Value",
      applyOncePerCustomer: "Limit to one use per customer",
      isHidden: "Hidden",
      usageLimit: "Redeem Total",
      isLimitToNewCustomer: "Limit to new customer",
      startDate: "Start Date",
      endDate: "End Date",
      status: "Status"
    }
  }
};
